/**
 * formatRelativeAge — convert an ISO timestamp to a human-readable relative string.
 * Prefers `updatedAt`; falls back to `createdAt`.
 *
 * Output examples:
 *   < 60 s  → "just now"
 *   < 60 m  → "17m"
 *   < 24 h  → "3h"
 *   >= 1 d  → "5d"
 */
export function formatRelativeAge(updatedAt: string, createdAt?: string): string {
  const ref = updatedAt || createdAt;
  if (!ref) return '—';

  const diffMs = Date.now() - new Date(ref).getTime();
  if (diffMs < 0) return 'just now';

  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 60) return 'just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;

  const days = Math.floor(hours / 24);
  return `${days}d`;
}

/**
 * formatCad — format a number as a CAD currency string.
 */
export function formatCad(amount: number): string {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
